import { Text } from "@chakra-ui/react";

export const EMPTY_CELL = "-";

const EmptyCell = () => {
  return <Text fontWeight="bold">{EMPTY_CELL}</Text>;
};

export { EmptyCell };
